import { Component, inject} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TabsModule } from 'primeng/tabs';
import { RouterModule } from '@angular/router';
import { MegaMenu } from 'primeng/megamenu';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { MenuComponent } from "./shared/components/menu/menu.component";
import { StateService } from './shared/services/state.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ErrorComponent } from "./features/error/error.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    TabsModule,
    RouterOutlet,
    RouterModule,
    ButtonModule,
    CommonModule,
    AvatarModule,
    MenuComponent,
    ProgressSpinnerModule,
    ErrorComponent
],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {


  title = 'MoH-Client';
  private _stateService = inject(StateService);

  getTables$ = this._stateService.getTables$

  isLoading = this._stateService.isLoading;

  hasError = this._stateService.hasError;
  error = this._stateService.error;

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.



  }


}
